import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAddressCompleteGuard } from '@gk/gk-modules';
import { CompositeGuard } from '../../guards/composite/composite.guard';
import { MainRoutes } from '../../guards/guard.models';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRequestsListComponent } from '../../shared/main-requests-list/main-requests-list.component';
import { NewPropertyLeaseRequestComponent } from './new-property-lease-request/new-property-lease-request.component';
import { PropertyLeasePortalComponent } from './property-lease-portal.component';

const propertyLeasePortalRoutes: Routes = [
  {
    path: MainRoutes.PropertyLease,
    component: PropertyLeasePortalComponent,
    canActivate: [CompositeGuard],
    data: {
      guards: [SessionGuard, IsAddressCompleteGuard],
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: NewPropertyLeaseRequestComponent,
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(propertyLeasePortalRoutes)],
  providers: [CompositeGuard, SessionGuard, IsAddressCompleteGuard],
  exports: [RouterModule],
})
export class PropertyLeasePortalRoutingModule {}
